export default __webpack_public_path__ + "static/media/le_lion11.26913018.jpg";